import { render, staticRenderFns } from "./ChannelCreate.vue?vue&type=template&id=7b577d01&lang=pug&"
import script from "./ChannelCreate.vue?vue&type=script&lang=ts&"
export * from "./ChannelCreate.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelCreate.vue?vue&type=style&index=0&id=7b577d01&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports